import T from 'i18n-react'
import * as R from 'ramda'
import { createSelector } from 'reselect'
import {
  createSelectorWithPath,
  labelSelectorFunc,
  entitiesSelector
} from 'helpers/ComponentSelectorUtil'

const valuesSelectorFunc = state => state.values ? state.values : []
const hintSelectorFunc = state => (state.defaultValue) ? T.translate(state.defaultValue) : ''

const typeSelectorFunc = state => state.types
const vendorSelectorFunc = state => state.vendors
const partNumberSelectorFunc = state => state.partNumbers

const typeSelectorHoc = (typeSelector) => (
  createSelector(
    entitiesSelector,
    typeSelector,
    (entities, refs) => refs.map(({id, type}) => {
      const value = entities[type][id].value
      return { value, label: value }
    })
  )
)

const vendorSelectorHoc = (vendorSelector) => (
  createSelector(
    entitiesSelector,
    vendorSelector,
    (entities, refs) => refs.map(({id, type}) => {
      const value = entities[type][id].value
      return { value, label: value }
    })
  )
)

const partNumberSelectorHoc = (partNumberSelector) => (
  createSelector(
    entitiesSelector,
    partNumberSelector,
    (entities, refs) => refs.map(({id, type}) => {
      const value = entities[type][id].value
      return { value, label: value }
    })
  )
)

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const labelSelector = withPath(labelSelectorFunc)
  const valuesSelector = withPath(valuesSelectorFunc)
  const hintSelector = withPath(hintSelectorFunc)

  const typeSelector = withPath(typeSelectorFunc)
  const vendorSelector = withPath(vendorSelectorFunc)
  const partNumberSelector = withPath(partNumberSelectorFunc)

  const typeSourceSelector = typeSelectorHoc(typeSelector)
  const vendorSourceSelector = vendorSelectorHoc(vendorSelector)
  const partNumberSourceSelector = partNumberSelectorHoc(partNumberSelector)
  return {
    hintSelector,
    valuesSelector,
    labelSelector,
    typeSourceSelector,
    vendorSourceSelector,
    partNumberSourceSelector
  }
}
